import { GET_DRUGS_LAB_TESTS_FROM_SYM_DIA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    drugs: Drug[];
    lab_tests: LabTest[];
}

export interface LabTest {
    id: string;
    name: string;
}

export interface Drug {
    id: string;
    name: string;
    manufacturer_name: string;
    product_type: string;
    generic_name: string;
    dosage?: {
        df_id?: string;
        unit?: string;
        unit_val?: string;
        unit_id?: string;
        unit_name?: string;
        dosage?: string;
        dosage_form?: string;
        days?: string;
        food?: string;
    };
    soa?: boolean;
}

export default (symIds?: string, diaIds?: string): Promise<Response> =>
    fetchWithRefresh(GET_DRUGS_LAB_TESTS_FROM_SYM_DIA(symIds || '', diaIds || '')).then((res) =>
        res.json(),
    );
